import { createApp } from "vue";
import App from "./App.vue";
import "./assets/styles/index.less";
import ViewUIPlus from "view-ui-plus";
// import router from './router'
import router from "./router/auth/permission";
import store from "./store";
import httpRequest from "@/utils/request";
import config from "@/configs/defaultConfigs";

// import './mock'
import { createI18n } from "vue-i18n";
import zh from "@/i18n/locale/zh-CN";
import en from "@/i18n/locale/en-US";

import renderValue from "@/components/Render/renderValue";
import SvgIcon from "@/components/icons";

import DictSelect from "@/components/Form/DictSelect";
import print from 'vue3-print-nb'

const i18n = createI18n({
  allowComposition: true,
  globalInjection: true,
  legacy: false,
  locale: "zh-CN",
  messages: {
    "zh-CN": zh,
    "en-US": en,
  },
});

const app = createApp(App);

// register globally
app.component("renderValue", renderValue);
app.component("svg-icon", SvgIcon);
app.component("dict-select", DictSelect);
app.config.globalProperties.isAuth = (permissions) => {
  return (
    !permissions ||
    !permissions.length ||
    (Array.isArray(permissions)
      ? permissions.every((permission) =>
          store.state.permission.permissions.includes(permission)
        )
      : store.state.permission.permissions.includes(permissions))
  );
};
app.config.globalProperties.$http = httpRequest;
app.config.globalProperties.$conf = config.Z || config;
app
  .use(i18n)
  .use(store)
  .use(router)
  .use(ViewUIPlus, {
    i18n,
  })
  .use(print)
  .mount("#app");
